import Vue from "vue";
import router from "./router";
import { Message, MessageBox } from "element-ui";
import NodeRSA from "jsencrypt";

export const errorHandle = error => {
  switch (error.response.status) {
    case 400:
      MessageBox.confirm(error.response.data, "Error", {
        confirmButtonText: "Confirm",
        cancelButtonText: "Cancel",
        type: "error"
      })
        .then(() => {})
        .catch(() => {});
      // Message({
      //   message: error.response.data,
      //   type: 'error',
      //   duration: 1500,
      //   customClass: 'element-error-message-zindex'
      // })
      break;
    case 401:
      router.push({
        name: "login"
      });
      break;
    case 405:
      Message({
        message: "http request method error",
        type: "error",
        duration: 1500,
        customClass: "element-error-message-zindex"
      });
      break;
    case 500:
      Message({
        message: "server error",
        type: "error",
        duration: 1500,
        customClass: "element-error-message-zindex"
      });
      break;
    case 501:
      Message({
        message: "server does not support",
        type: "error",
        duration: 1500,
        customClass: "element-error-message-zindex"
      });
      break;
  }
  return Promise.reject(error);
};



// WEBPACK FOOTER //
// ./src/utils.js